import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const SIZES = {
  S: "s",
  M: "m",
  L: "l",
  XL: "xl",
};

export const STYLE_TYPES = {
  RELOAD: "Reload",
  SUCHEN: "Suchen",
  DROPDOWN_CLOSE: "Dropdown_close",
  SCHLIESSEN: "Schliessen",
  PFEIL_NACH_LINKS: "Pfeil_nach_links",
  PFEIL_NACH_RECHTS: "Pfeil_nach_rechts",
  ETIKETT: "Etikett",
};

export const ICON_STYLE = {
  Reload: "outline",
  Suchen: "outline",
  Dropdown_close: "flat",
  Schliessen: "outline",
  Pfeil_nach_links: "outline",
  Pfeil_nach_rechts: "outline",
  Etikett: "outline",
};

const Icon = (props) => {
  const { type, className, size, ...rest } = props;

  const componentClass = classnames(
    "sal-icon",
    `sal-icon--${type}`,
    "cvds-icon",
    `cvds-icon--${type}`,
    `cvds-icon--style-${ICON_STYLE[type]}`,
    {
      [`cvds-icon--size-${size}`]: size,
    },
    className,
  );

  return <span className={componentClass} {...rest} />;
};

Icon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SIZES)),
  type: PropTypes.oneOf(Object.values(STYLE_TYPES)).isRequired,
};

export default Icon;
